export default async function initPaymentService() {
	if (window.parametrize('VUE_APP_PAYMENT_LIB_LINK')) {
		const script = document.createElement('script');
		script.async = true;
		script.src = window.parametrize('VUE_APP_PAYMENT_LIB_LINK');
		document.body.appendChild(script).id = 'payment-lib';
	}
}
